// API Configuration
// Use environment variable if available, otherwise fallback to default
export const API_BASE_URL = '/api';

// Types
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  address: string;
  dateOfBirth: string;
  occupation: string;
  gymId?: string; // GUID as string
  isSuperAdmin?: boolean;
  isActive?: boolean;
  roles?: string[];
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  user: User;
  roles: string[];
}

export interface Enquiry {
  enquiryId: number;
  gymId: string; // GUID as string
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isWhatsappNumber: boolean;
  address: string;
  city: string;
  gender: string;
  dateOfBirth: string;
  occupation: string;
  interestType?: string; // New field: Cardio, Strength, etc.
  remark?: string; // New field: Additional notes
  isConverted: boolean;
  convertedDate?: string;
  createdby: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface MembershipPlan {
  membershipPlanId: number;
  gymId: string; // GUID as string
  planName: string;
  planType: string;
  durationInMonths: number;
  price: number;
  description: string;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface MembersMembership {
  membersMembershipId: number;
  gymId: string; // GUID as string
  enquiryId: number;
  membershipPlanId: number;
  startDate: string;
  durationInMonths: number;
  endDate: string;
  totalAmount: number;
  paidAmount: number;
  remainingAmount: number;
  nextPaymentDueDate: string;
  isInactive?: boolean;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  enquiry?: Enquiry;
  membershipPlan?: MembershipPlan;
}
